<template>
  <div class="ts-collapse">
    <div v-if="open" class="content">
      <slot></slot>
    </div>
    <div class="title">
      <div class="top-row">
        <div class="title-content">
          <slot v-if="!hasOpenTitle || !open" name="title"></slot>
          <slot v-else name="title-open"></slot>
        </div>
        <div class="toggle" :class="{ reverse: open }" @click="handleToggleClick">
          <ChevronDownLarge />
        </div>
      </div>
      <div v-if="hasOpenSubtitle && open">
        <slot name="subtitle-open"></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ts-collapse {
  display: flex;
  flex-direction: column-reverse;

  .title {
    border-radius: 38px;
    background: #ebecf0;
    box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
    border: solid 2px rgba(255, 255, 255, 0.32);
    background-blend-mode: soft-light, normal;
    background-image: linear-gradient(274deg, #000000, var(--fills-neutral-white) 0%),
      linear-gradient(to bottom, #ebecf0, #ebecf0);

    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #6d7587;

    padding: 18px 30px;
    display: flex;
    flex-direction: column;

    .top-row {
      flex-grow: 1;
      display: flex;
      align-items: center;
    }

    .title-content {
      flex-grow: 1;
    }

    .toggle {
      cursor: pointer;
      transition: transform 0.3s;

      &.reverse {
        transform: rotate(180deg);
      }
    }
  }

  .content {
    padding: 59px 30px 30px;
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
    box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
    border: solid 2px rgba(255, 255, 255, 0.32);
    background-blend-mode: soft-light, normal;
    background-image: linear-gradient(324deg, #000000 100%, var(--fills-neutral-white) -6%),
      linear-gradient(to bottom, #ebecf0, #ebecf0);
    margin-top: -34px;
  }
}
</style>

<script>
import ChevronDownLarge from '../../assets/chevron-down-large.svg';

export default {
  name: 'TsCollapse',
  components: {
    ChevronDownLarge
  },
  props: {
    startOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: this.startOpen
    };
  },
  watch: {
    startOpen(value) {
      this.open = value;
    }
  },
  computed: {
    hasOpenTitle() {
      return this.$slots['title-open'];
    },
    hasOpenSubtitle() {
      return this.$slots['subtitle-open'];
    }
  },
  methods: {
    handleToggleClick() {
      this.open = !this.open;
      this.$emit('input', this.open);
    }
  }
};
</script>
